import { FC } from 'react';

type Props = {
  className?: string;
};

export const IconCards: FC<Props> = ({ className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="164"
    height="136"
    viewBox="0 0 164 136"
    fill="none"
    className={className}
  >
    <path
      d="M40.5417 6.86479L39.1388 19.5031L134.302 18.7468L133.859 14.7312C133.486 12.8081 131.68 10.2523 129.707 10.0809L45.4537 2.86515C43.0015 2.65174 40.8108 4.43778 40.539 6.86021L40.5417 6.86479Z"
      fill="url(#paint0_linear_933_12600)"
    />
    <path
      d="M63.7806 72.2525L38.4752 70.4445C35.8133 70.2557 33.8662 67.9655 34.1447 65.3408L39.7589 11.8699C40.0333 9.25993 42.4019 7.31294 45.05 7.5219L130.627 14.3055C133.31 14.5193 135.243 16.8608 134.911 19.5036L128.115 73.317C127.788 75.9019 125.411 77.7919 122.789 77.5619L96.8312 75.2507L63.7806 72.2525Z"
      fill="url(#paint1_linear_933_12600)"
    />
    <path
      d="M127.751 109.624L143.03 106.99L145.801 47.2315L141.21 45.4069L130.237 42.4599C128.716 42.195 127.243 43.1247 126.829 44.6075L109.933 101.907C109.508 103.438 110.351 105.036 111.857 105.551L119.959 108.326L127.751 109.624Z"
      fill="url(#paint2_linear_933_12600)"
    />
    <path
      d="M134.704 110.778L122.9 108.752C121.126 108.446 119.997 106.669 120.49 104.959L137.068 47.1438C137.549 45.4677 139.376 44.5743 141.018 45.2163L178.068 59.6529C179.53 60.2216 180.321 61.8068 179.887 63.2955L165.185 113.787C164.766 115.232 163.325 116.122 161.829 115.869L151.86 114.173C151.86 114.173 140.856 112.186 134.704 110.778Z"
      fill="url(#paint3_linear_933_12600)"
    />
    <path
      d="M-3.46282 43.3019L-10.8846 48.9261L89.9284 67.9291L90.4163 133.809L96.1555 129.215C97.0721 128.485 97.6309 127.392 97.6866 126.211L99.7037 63.9864C99.8012 61.8933 98.319 60.0471 96.2533 59.6874L-0.14683 42.4276C-1.33282 42.2215 -2.53721 42.5407 -3.4587 43.299L-3.46282 43.3019Z"
      fill="url(#paint4_linear_933_12600)"
    />
    <path
      d="M86.0034 134.751L-7.3292 114.175C-9.3602 113.727 -10.8567 111.995 -10.9928 109.921L-12.3871 51.9941C-12.5935 48.9456 -9.85125 46.5265 -6.84074 47.0943L89.6439 64.6102C91.9361 65.043 93.5617 67.0918 93.4572 69.4137L91.7334 130.413C91.6037 133.326 88.8527 135.406 86.0034 134.751Z"
      fill="url(#paint5_linear_933_12600)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_933_12600"
        x1="68.6436"
        y1="58.4943"
        x2="87.6993"
        y2="-32.2818"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#609399" />
        <stop offset="1" stopColor="#0F3B40" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_933_12600"
        x1="69.6562"
        y1="112.536"
        x2="115.576"
        y2="-19.6362"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0F3B40" />
        <stop offset="1" stopColor="#609399" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_933_12600"
        x1="143.944"
        y1="115.067"
        x2="126.511"
        y2="46.36"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#609399" />
        <stop offset="1" stopColor="#B1CCCF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_933_12600"
        x1="156.791"
        y1="117.855"
        x2="135.609"
        y2="46.5388"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B1CCCF" />
        <stop offset="1" stopColor="#609399" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_933_12600"
        x1="33.3543"
        y1="17.2594"
        x2="38.1669"
        y2="153.946"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DEF5F9" />
        <stop offset="1" stopColor="#18C2DE" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_933_12600"
        x1="13.7929"
        y1="35.4608"
        x2="5.44606"
        y2="157.696"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#18C2DE" />
        <stop offset="1" stopColor="#DEF5F9" />
      </linearGradient>
    </defs>
  </svg>
);
